module.exports = __webpack_public_path__ + "img/indiba_2021.c515bfc6.png";